// extracted by mini-css-extract-plugin
module.exports =  {"item":"cvQOPaeO","left":"_nyBxN_5","right":"QYwceVdD","logo":"MB3iMA9D","creditsPill":"HZViI9vX","error":"Xa_AjjYT","link":"NH26cOyA"};